/** Root layout for dt widgets that should fill grid height and distribute rows. */
export const dtWidgetFilledColumnSx = {
  flex: 1,
  minHeight: 0,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  py: 0.5,
};

export function buildDTWidgetCardSx(basic = {}, theme = 'dark') {
  const isDark = theme === 'dark';
  return {
    // Colors always derived from the active theme — never stored values
    backgroundColor: isDark ? '#1a1a1a' : '#ffffff',
    border: `${basic.borderSize || 1}px solid ${isDark ? '#333' : '#ddd'}`,
    borderRadius: `${basic.borderRadius || 4}px`,
    color: isDark ? '#fff' : '#000',
    height: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative',
  };
}

export function dtWidgetHeaderSx(isDark) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '4px 8px',
    borderBottom: `1px solid ${isDark ? '#333' : '#eee'}`,
    minHeight: 32,
    flexShrink: 0,
  };
}

export function dtWidgetTitleSx(basic = {}, isDark = false) {
  return {
    fontSize: basic.fontSize || 13,
    fontFamily: basic.fontType || 'Roboto',
    fontWeight: 600,
    color: isDark ? '#ddd' : '#333',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };
}

export const staleOverlaySx = {
  position: 'absolute',
  top: 32,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 165, 0, 0.08)',
  border: '1px solid rgba(255, 165, 0, 0.3)',
  zIndex: 2,
  pointerEvents: 'none',
};

export const disconnectedOverlaySx = {
  position: 'absolute',
  top: 32,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 0, 0, 0.12)',
  border: '1px solid rgba(255, 0, 0, 0.3)',
  zIndex: 2,
};
